<template>
  <div class="loader">
    <div class="loader__line-short"></div>
    <div class="loader__line-long"></div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CalcLoader',
})
</script>

<style lang="scss" scoped>
.loader {
  position: relative;
  width: 100%;
  height: 4px; /* Высота лоадера */
  background-color: rgba(0, 151, 206, 0.3); /* Цвет фона */
  overflow: hidden; /* Скрыть часть линии, выходящую за пределы */
}

.loader__line-short {
  position: absolute;
  height: 100%;
  background-color: #0097ce; /* Цвет бегущей линии */
  animation: loading-short 2.2s linear infinite; /* Анимация */
}

.loader__line-long {
  position: absolute;
  height: 100%;
  background-color: #0097ce; /* Цвет бегущей линии */
  animation: loading-long 2.2s linear infinite; /* Анимация */
}

@keyframes loading-short {
  0% {
    left: -200%;
    right: 100%;
  }
  60% {
    left: 107%;
    right: -8%;
  }
  100% {
    left: 107%;
    right: -8%;
  }
}

@keyframes loading-long {
  0% {
    left: -90%;
    right: 100%;
  }
  60% {
    left: -90%;
    right: 100%;
  }
  100% {
    left: 100%;
    right: -35%;
  }
}
</style>
